/* eslint-disable */
import axios from 'axios';
import store from '../store/index';
import $qs from 'qs';
// import router from '../../pages/venice';
import $Cookies from 'js-cookie';
import { Message } from 'element-ui';
var messageFlag = true;


//请求拦截
axios.interceptors.request.use(
  config => {
    //可将store导入并配置请求token
    // config.headers.token = store.state.token
    // console.log(store._actions.checkLogin())
    // 判断本地是否存在UUID 
    let url = window.location.href;
    let UUID = $qs.parse(url.split('?')[1]).UUID;
    if (UUID === undefined) {
      UUID = $Cookies.get('UUID')
    } else {
      $Cookies.set('UUID', UUID)
    }
    if(UUID) {
      let obj ={};
      obj['isLogin'] = true;
      obj['UUID'] = UUID;
      store.commit('CHECK_LOGIN', obj)
    }else {
      store.commit('LOGIN_OUT')
    }
    
    return config
  },err=>{
    return Promise.resolve(err)
  });

//响应拦截
axios.interceptors.response.use(
  resp =>{
    if (resp.data.status === 99999&& !resp.data.success && messageFlag) {
      console.log(9999)
      Message.error({
        message: resp.data.message || resp.data.msg,
        showClose: true,
        duration: 0
      });

      messageFlag = false;
      setTimeout(() => {
        messageFlag = true
      },2000)
    }
    if(resp.data.code === 99999){
      // Message.error({
      //   message:resp.data.message || resp.data.msg,
      //   showClose: true,
      //   duration: 0
      // });
      setTimeout(function(){
        location.hash = `/404?err=${resp.data.message || resp.data.msg}`
      },1500)
    }
    return resp
  },error =>{
    if (error.response) {
      let status = error.response.status;
      // 根据状态码，返回错误类型
      // error.response.statusText = trans(status);
      if (status === 701 || status === 706 || status === 707) {
      } else if (status >= 500) {
        let msg = trans(status);
      }else if(status === 403){
        $Cookies.remove('UUID');
        store.commit('LOGIN_OUT');
        location.reload()
      }
      //抛出错误给链式catch()
      return Promise.reject(error)
    }
  }
);

//判断请求错误类型
function trans (status) {
  switch (status) {
    case 400:
      return '错误的请求';
    case 407:
      return '资源未授权';
    case 403:
      return 'Login expired';
    case 404:
      return '资源不存在';
    case 500:
      return '服务出错了';
    case 504:
      return '服务出错了';
    case 502:
      return '服务器暂时不可用';
    case 503:
      return '服务忙';
    case 701: // 无效的授权
      return '登录已过期';
    case 702:
      return '账号未激活';
    case 703:
      return '账号被冻结';
    case 704:
      return '账号已停用';
    case 705:
      return '账号审核失败';
    case 706:
      return '账号被踢出';
    case 707:
      return '非法的授权';
  }
}

/** 判断参数元素的类型
 *  ({}).toString.call(ele) ===> [object type],
 *  str.match(regexp) ===> 返回array,(如果字符串匹配到了表达式，会返回一个数组，
 *  数组的第一项是进行匹配完整的字符串===>' type'    ，之后的项是用圆括号捕获的结果===>'type' 。如果没有匹配到，返回null);
 *  toLowerCase() 全部转换为小写*/
function toType (ele) {
  return ({}).toString.call(ele).match(/\s([A-Za-z]+)/)[1].toLowerCase()
}
/** 过滤参数
 * 判断参数的类型， 并去除每一项值字符串前后的空格*/
function filterNull (o) {
  for(let key in o){
    if(o[key] === null){
      delete o[key]
    }
    if(toType(o[key]) === 'string'){
      // o[key] = o[key].trim()
      // o[key] = o[key].replace(" ", "")
      o[key] = o[key].replace(/(^\s*)|(\s*$)/g, '')
    }else if(toType(o[key])==='object'||toType(o[key])==='array'){
      o[key] = filterNull(o[key])
    }else if(toType(o[key]) === 'number'){
      o[key] = Number(o[key])
    }
  }
  return o
}

let base = '';

function apiAxios (method, url, params={}, callback=null, failure=null) {
  let lang = $Cookies.get('lang')
  params['lang'] = lang || 'zh_CN';
  //过滤参数，取消所有用户输入的前后空格
  // Space 为true不取消前后空格并删除该参数
  if (params) {
    if(!params['Space']){
      params = filterNull(params);
    }else{
      delete params.Space
    }
    if(method==='POST'){
      params = $qs.stringify(params)
    }
  }
  // `data`是要作为请求主体发送的数据
  // 仅适用于请求方法“PUT”，“POST”和“PATCH”
  let data = method === 'POST' || method === 'PUT' ? params : null;
  // `params`是要与请求一起发送的URL参数
  // 必须是纯对象或URLSearchParams对象
  let param = method === 'GET' || method === 'DELETE' ? params : null;
  //执行axios请求
  axios({
    method: method,
    url: url,
    // `data`是要作为请求主体发送的数据
    // 仅适用于请求方法“PUT”，“POST”和“PATCH”
    data: data,
    // `params`是要与请求一起发送的URL参数
    // 必须是纯对象或URLSearchParams对象
    params: param,
    // `baseURL`将被添加到`url`前面，除非`url`是绝对的。
    // 可以方便地为 axios 的实例设置`baseURL`，以便将相对 URL 传递给该实例的方法。
    baseURL: base,
    withCredentials: true // 是否跨域
  }).then(function (res) {
    callback(res)
  }).catch(function (err) {
    if (err.response) {
      let res = err.response
      failure({code: res.status, message: res.statusText})
    } else if (err) {
      if (err.toString().indexOf('{') > 0) {
        // failure(evil(err.replace(/[\r\n]/g, '')))
      }
    }
  })
}
//抛出未知的错误
function tip (e) {
  if (e) {
    return e.message
  } else {
    console.log('unknown error')
  }
}

export default {
  get: function (url, params, callback, failure) {
    apiAxios('GET', url, params, callback, failure)
  },
  post: function (url, params, callback, failure) {
    apiAxios('POST', url, params, callback, failure)
  },
  put: function (url, params, callback, failure) {
    apiAxios('PUT', url, params, callback, failure)
  },
  delete: function (url, params, callback, failure) {
    apiAxios('DELETE', url, params, callback, failure)
  },
  tip: tip
}



// WEBPACK FOOTER //
// ./src/common/axios/index.js